import { useEffect, useState } from 'react';

import { FLIGHT_SEARCH_QUERY_PARAM_KEYS } from '@components/views/flight/constants';
import { useFindAirportByAirportCode } from '@components/views/flight/hooks/flight.query';
import { URL_DATE_FORMAT, convertDateToMomentObject } from '@utils/dateUtil';

import { IFlightSearchBarState } from '../types/flight';

export type FlightSearchBarQuery = Omit<IFlightSearchBarState, 'cabinClass'>;

export const useFlightQuery = (query, enabled) => {
  const [values, setValues] = useState<Partial<FlightSearchBarQuery>>();

  const {
    [FLIGHT_SEARCH_QUERY_PARAM_KEYS.departureAirportCode]: departureAirportCode,
    [FLIGHT_SEARCH_QUERY_PARAM_KEYS.departureIsCity]: departureIsCity,
    [FLIGHT_SEARCH_QUERY_PARAM_KEYS.arrivalAirportCode]: arrivalAirportCode,
    [FLIGHT_SEARCH_QUERY_PARAM_KEYS.arrivalIsCity]: arrivalIsCity,
    [FLIGHT_SEARCH_QUERY_PARAM_KEYS.isOneWay]: isOneWay = 'false',
    [FLIGHT_SEARCH_QUERY_PARAM_KEYS.departureDate]: departureDate,
    [FLIGHT_SEARCH_QUERY_PARAM_KEYS.returnDate]: returnDate,
  } = query as { [key: string]: string };

  const { data: departureAirportData } = useFindAirportByAirportCode(
    departureAirportCode as string,
    departureIsCity && departureIsCity === '1' ? true : false,
    enabled
  );
  const { data: arrivalAirportData } = useFindAirportByAirportCode(
    arrivalAirportCode as string,
    arrivalIsCity && arrivalIsCity === '1' ? true : false,
    enabled
  );

  useEffect(() => {
    if (!departureAirportData?.length) return;
    setValues((previousValues) => ({
      ...previousValues,
      departureAirport: departureAirportData[0],
    }));
  }, [departureAirportData]);

  useEffect(() => {
    if (!arrivalAirportData?.length) return;
    setValues((previousValues) => ({
      ...previousValues,
      arrivalAirport: arrivalAirportData[0],
    }));
  }, [arrivalAirportData]);

  useEffect(() => {
    if (!departureDate) return;

    setValues((previousValues) => ({
      ...previousValues,
      startDate: convertDateToMomentObject(
        departureDate as string,
        URL_DATE_FORMAT
      ),
    }));
  }, [departureDate]);

  useEffect(() => {
    if (!returnDate) return;
    setValues((previousValues) => ({
      ...previousValues,
      endDate: convertDateToMomentObject(returnDate as string, URL_DATE_FORMAT),
    }));
  }, [returnDate]);

  useEffect(() => {
    setValues((previousState) => ({
      ...previousState,
      isOneWay: isOneWay === 'true',
    }));
  }, [isOneWay]);

  return values;
};
